import React, { useState } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IAlertBarProps extends IBaseElementProps {
	children?: any;
	closeLabel?: string;
	isHidden?: boolean;
	useLocalStorage?: boolean;
	localStorageKey?: string;
	alertHash?: string;
	isClosable?: boolean;
	indexNum?: number;
}

const AlertBarModified: React.FC<IAlertBarProps> = ({
	children,
	className,
	classNames = [],
	closeLabel = 'Close',
	isHidden = false,
	useLocalStorage = true,
	localStorageKey = 'alert-bar-closed',
	alertHash = '1',
	isClosable,
	indexNum,
}) => {
	const [hideAlertBar, setHideAlertBar] = useState<boolean>(
		isHidden === true ||
			(useLocalStorage === true &&
				localStorage.getItem(localStorageKey + '_' + indexNum) ===
					alertHash),
	);

	return (
		<div
			className={
				className ||
				cn(
					'alert-bar',
					'alert',
					hideAlertBar && 'd-none',
					!isClosable && 'no-close',
					...classNames,
				)
			}
		>
			{children}

			{isClosable && (
				<button
					type="button"
					className="btn-close"
					aria-label={closeLabel}
					onClick={(e) => {
						if (useLocalStorage) {
							localStorage.setItem(
								localStorageKey + '_' + indexNum,
								alertHash,
							);
						}
						setHideAlertBar(true);
					}}
				/>
			)}
		</div>
	);
};

export default AlertBarModified;
